import { useState, useCallback, useRef } from 'react';

interface TiltOptions {
  maxTilt?: number;
  scale?: number;
  speed?: number;
}

export function useTiltEffect({ maxTilt = 15, scale = 1.03, speed = 400 }: TiltOptions = {}) {
  const [style, setStyle] = useState<React.CSSProperties>({});
  const ref = useRef<HTMLDivElement>(null);
  const frameRef = useRef<number>(0);

  const onMouseMove = useCallback((e: React.MouseEvent) => {
    if (!ref.current) return;

    if (frameRef.current) {
      cancelAnimationFrame(frameRef.current);
    }

    frameRef.current = requestAnimationFrame(() => {
      if (!ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;

      const tiltX = (y - 0.5) * -maxTilt;
      const tiltY = (x - 0.5) * maxTilt;

      setStyle({
        transform: `perspective(1200px) rotateX(${tiltX}deg) rotateY(${tiltY}deg) scale3d(${scale}, ${scale}, ${scale})`,
        transition: 'transform 0.1s ease-out',
      });
    });
  }, [maxTilt, scale]);

  const onMouseLeave = useCallback(() => {
    if (frameRef.current) {
      cancelAnimationFrame(frameRef.current);
    }

    setStyle({
      transform: 'perspective(1200px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)',
      transition: `transform ${speed}ms cubic-bezier(0.23, 1, 0.32, 1)`,
    });
  }, [speed]);

  return { ref, style, onMouseMove, onMouseLeave };
}